import MerchantInstoreMaterialDeliveryApi from '@/api/merchant/instore-material-delivery'

const state = {
  creating: false,
  fetching: false,
  lastError: null,
  orderMaterialList: [],
  totalRecords: 0,
}

const mutations = {
  SET_CREATING(state, value) {
    state.creating = value
  },
  SET_FETCHING(state, value) {
    state.fetching = value
  },
  SET_ERROR(state, value) {
    state.lastError = value
  },
  SET_ORDER_MATERIAL_LIST(state, value) {
    state.orderMaterialList = value
  },
  SET_TOTAL_RECORDS(state, value) {
    state.totalRecords = value
  },
}

const getters = {}

const actions = {
  async createInstoreMaterialDelivery({ commit }, data) {
    try {
      commit('SET_CREATING', true)

      const response = await MerchantInstoreMaterialDeliveryApi.create(data)

      return response
    } catch (error) {
      commit('SET_ERROR', error)

      throw error
    } finally {
      commit('SET_CREATING', false)
    }
  },
  async fetchOrderMaterialList({ commit }, data) {
    try {
      commit('SET_FETCHING', true)

      const {
        data: response,
      } = await MerchantInstoreMaterialDeliveryApi.fetchList(data)

      commit('SET_ORDER_MATERIAL_LIST', response.data)
      commit('SET_TOTAL_RECORDS', response.total)
    } catch (error) {
      commit('SET_ERROR', error)

      throw error
    } finally {
      commit('SET_FETCHING', false)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
